import { formatChatDate } from '../utils/date-utils';

interface DateSeparatorProps {
  date: Date;
}

export function DateSeparator({ date }: DateSeparatorProps) {
  return (
    <div className="my-6 flex items-center justify-center">
      <div className="bg-muted rounded-full px-3 py-1">
        <span className="text-foreground-secondary text-xs font-medium">
          {formatChatDate(date)}
        </span>
      </div>
    </div>
  );
}
